import React from "react";
import {
  FaMicrochip,
  FaCheckCircle,
  FaCode,
  FaClipboardCheck,
  FaCogs,
  FaSearch,
  FaClock,
  FaIndustry,
  FaShieldAlt,
  FaRocket,
  FaBolt,
  FaProjectDiagram,
  FaDatabase,
  FaCloud,
  FaLightbulb,
  FaGlobe,
  FaBroadcastTower,
  FaCamera,
  FaRobot,
  FaSolarPanel,
  FaLock,
  FaBell,
  FaTruck,
} from "react-icons/fa";
import "./productGrid.css"

interface Product {
  icon: string; // string key for dynamic icons
  title: string;
  description: string;
}

interface ProductGridProps {
  id?: string;
  title: string;
  products: Product[];
  variant?: string;
}

// Dynamic icon map using 'any' for flexibility
const iconMap: Record<string, any> = {
  FaMicrochip: FaMicrochip,
  FaCheckCircle: FaCheckCircle,
  FaCode: FaCode,
  FaClipboardCheck: FaClipboardCheck,
  FaCogs: FaCogs,
  FaSearch: FaSearch,
  FaClock: FaClock,
  FaIndustry: FaIndustry,
  FaShieldAlt: FaShieldAlt,
  FaRocket: FaRocket,
  FaBolt: FaBolt,
  FaProjectDiagram: FaProjectDiagram,
  FaDatabase: FaDatabase,
  FaCloud: FaCloud,
  FaLightbulb: FaLightbulb,
  FaGlobe: FaGlobe,
  FaBroadcastTower: FaBroadcastTower,
  FaCamera: FaCamera,
  FaRobot: FaRobot,
  FaSolarPanel: FaSolarPanel,
  FaLock: FaLock,
  FaBell: FaBell,
  FaTruck: FaTruck,
};

// Function to render icon dynamically
const getIcon = (name: string): React.ReactNode | null => {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.warn(`Unknown icon: ${name}`);
    return null;
  }
  return React.createElement(IconComponent, { className: "product-icon-svg" });
};

export const ProductGrid: React.FC<ProductGridProps> = ({
  title,
  products,
  id,
  variant,
}) => {
  return (
    <section className={`product-grid-section ${variant || ""}`} id={id}>
      <h2 className="product-title">{title}</h2>
      <div className="product-grid-container">
        {products.map((p, i) => (
          <div key={i} className="product-card">
            <div className="product-icon">{getIcon(p.icon)}</div>
            <h3 className="product-card-title">{p.title}</h3>
            <p className="product-card-desc">{p.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};